module.exports = __webpack_public_path__ + "img/alexander-abramov-aleksandr-frolov.fd50ae19.png";